import { styled } from "@mui/material"

export const CardsContainer = styled("div")(() => ({
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 360px))",
    gap: "16px",
    width: "100%",
}))
